import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Backdrop as MuiBackdrop } from '@material-ui/core';
import { makeStyles } from '../../themes';
const useStyles = makeStyles(({ palette }) => ({
    root: {
        backgroundColor: palette.background.backdropOverlay,
    },
}));
export const Backdrop = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { root } = useStyles();
    return (_jsx(MuiBackdrop, Object.assign({ classes: {
            root,
        } }, props, { children: children }), void 0));
};
//# sourceMappingURL=Backdrop.js.map